const isEmptyObject = (obj: any) => 
    obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  
  const isEmptyArray = (arr: any) => Array.isArray(arr) && arr.length === 0;
  
  export const filterObject = (obj: any): any => {
    const filteredObj: any = {};
  
    // Iterate over the entries of the input object
    Object.entries(obj).forEach(([key, value]) => {
      // Add the value to the filtered object if it's valid
      if (value !== null && value !== undefined && value !== "") {
        if (typeof value === 'object' && !Array.isArray(value)) {
          if (!isEmptyObject(value)) {
            filteredObj[key] = value;
          }
        } else if (Array.isArray(value)) {
          if (!isEmptyArray(value)) {
            filteredObj[key] = value;
          }
        } else {
          filteredObj[key] = value;
        }
      }
    });
  
    return filteredObj;
  };


  export function convertCurlToJson(curlCommand: string) {
    const jsonOutput: any = {
      method: 'GET' as string,
      url: '',
      headers: {} as Record<string, string>,
      data: {} as any,
      payload_type: 'application/json' as string
    };
  
    if (!curlCommand || typeof curlCommand !== 'string') {
      return jsonOutput;
    }
    curlCommand = curlCommand.replace(/\\\n/g, ' ').replace(/\^/g, '');
    const tokens: string[] = [];
    let current = '';
    let inQuote = false;
    let quoteChar = '';
    let i = 0;
    while (i < curlCommand.length) {
      const char = curlCommand[i];
      if ((char === '"' || char === "'") && !inQuote) {
        inQuote = true;
        quoteChar = char;
        current += char;
      } else if (inQuote && char === quoteChar) {
        inQuote = false;
        current += char;
        tokens.push(current);
        current = '';
      } else if (inQuote) {
        current += char;
      } else if (char === ' ') {
        if (current) {
          tokens.push(current);
          current = '';
        }
      } else {
        current += char;
      }
      i++;
    }
    if (current) tokens.push(current);
  
    const cleanTokens = tokens.filter(t => t && t.trim());
  
    if (cleanTokens.length < 2 || cleanTokens[0] !== 'curl') {
      return jsonOutput;
    }
  
    let tokenIndex = 1;
    let explicitMethod = null;
    let hasG = false;
    let hasData = false;
    let hasT = false;
    let dataTokens: string[] = [];
    let authUserPass = '';
    let cookieStr = '';
    let isDataBinary = false;
      for (let idx = tokenIndex; idx < cleanTokens.length; idx++) {
      const token = cleanTokens[idx];
      if (token.startsWith('-X')) {
        let methodPart = token.replace('-X', '').trim();
        if (!methodPart && idx + 1 < cleanTokens.length) {
          methodPart = cleanTokens[idx + 1].trim();
          idx++;  // Skip next
        }
        if (methodPart) explicitMethod = methodPart.toUpperCase();
      } else if (token === '-G') {
        hasG = true;
      } else if (token.startsWith('-d') || token.startsWith('--data-raw') || token.startsWith('--data-binary') || token.startsWith('--data')) {
        hasData = true;
        if (token.startsWith('--data-binary')) isDataBinary = true;
        for (let dIdx = idx + 1; dIdx < cleanTokens.length; dIdx++) {
          if (cleanTokens[dIdx].startsWith('-')) break;
          dataTokens.push(cleanTokens[dIdx]);
        }
        break;
      } else if (token.startsWith('-F')) {
        hasData = true;
        for (let fIdx = idx; fIdx < cleanTokens.length; fIdx++) {
          if (cleanTokens[fIdx].startsWith('-F')) {
            dataTokens.push(cleanTokens[fIdx]);
          } else if (cleanTokens[fIdx].startsWith('-')) {
            break;
          } else {
            dataTokens.push(cleanTokens[fIdx]);
          }
        }
        break;
      } else if (token.startsWith('-T')) {
        hasT = true;
        if (idx + 1 < cleanTokens.length) dataTokens.push(cleanTokens[idx + 1]);
        idx++; 
      }else if (token.startsWith('-u')) {
        if (idx + 1 < cleanTokens.length) {
          authUserPass = cleanTokens[idx + 1];
          try {
            const base64 = window.btoa(authUserPass); 
            jsonOutput.headers['Authorization'] = `Basic ${base64}`;
          } catch (e) {
            console.error('btoa error:', e);
          }
          if (token.includes('--digest')) {
            jsonOutput.headers['Authorization'] = `Digest username="${authUserPass.split(':')[0]}"`;  // Simple digest
          }
        }
        idx++;
      }
    }
    if (explicitMethod) {
      jsonOutput.method = explicitMethod;
    } else if (hasT) {
      jsonOutput.method = 'PUT';  // -T implies PUT
    } else if (hasData && !hasG) {
      jsonOutput.method = 'POST';
    } else if (hasG) {
      jsonOutput.method = 'GET';  // -G forces GET
    }
    for (let idx = 1; idx < cleanTokens.length; idx++) {
      const token = cleanTokens[idx];  
      if (token.startsWith('-')) {
        if (token === '--location' || token === '-L') {
          if (idx + 1 < cleanTokens.length) {
            const nextToken = stripQuotes(cleanTokens[idx + 1]);
            if (nextToken.startsWith('http')) {
              jsonOutput.url = nextToken;
              break;
            }
          }
        }
        continue;
      }
      
      const stripped = stripQuotes(token);
      if (stripped.startsWith('http')) {
        jsonOutput.url = stripped;
        break;
      }
    }
      for (let idx = 1; idx < cleanTokens.length; idx++) {
      const token = cleanTokens[idx];
      if (token.startsWith('-H') || token.startsWith('--header')) {
        let headerStr = '';
        if (idx + 1 < cleanTokens.length) {
          headerStr = stripQuotes(cleanTokens[idx + 1]);
          const colonIndex = headerStr.indexOf(':');
          if (colonIndex > -1) {
            const key = headerStr.substring(0, colonIndex).trim();
            const value = headerStr.substring(colonIndex + 1).trim();
            jsonOutput.headers[key] = value;
          }
          idx++;  // Skip value
        }
      }
    }
  
    if (dataTokens.length > 0) {
      let bodyStr = dataTokens.join(' ').trim();
      bodyStr = stripQuotes(bodyStr);
      try {
        jsonOutput.data = JSON.parse(bodyStr);
      } catch {
        jsonOutput.data = bodyStr; 
      }
    }
      const contentType = jsonOutput.headers['Content-Type'] || '';
    if (contentType.includes('application/json')) {
      jsonOutput.payload_type = 'application/json';
    } else if (hasData && (dataTokens.some(t => t.includes('@') || t.startsWith('-F')) || hasT)) {
      jsonOutput.payload_type = 'multipart/form-data';
    } else if (hasData && !isDataBinary) {
      jsonOutput.payload_type = 'application/x-www-form-urlencoded';
    } else if (isDataBinary || hasT) {
      jsonOutput.payload_type = 'application/octet-stream';
    }
  
    return jsonOutput;
  }
  
  function stripQuotes(str: string): string {
    if (!str) return str;
    if ((str.startsWith('"') && str.endsWith('"')) || (str.startsWith("'") && str.endsWith("'"))) {
      return str.slice(1, -1);
    }
    return str;
  }
    function btoa(str: string): string {
    return btoa(str); 
  }


  export function replaceVariables(config: any[], data: any): any {
    if (typeof data === 'string') {
        // Replace the placeholder if it matches a config value
        const match = config?.find((conf: any) => data === `{{${conf.name}}}`);
        return match?.default_value || data;
    } else if (Array.isArray(data)) {
        // Recursively handle arrays
        return data.map((item: any) => replaceVariables(config, item));
    } else if (typeof data === 'object' && data !== null) {
        // Recursively handle objects
        return Object.fromEntries(
            Object.entries(data).map(([key, value]) => [key, replaceVariables(config, value)])
        );
    }
    return data; // Return as is if not a string, object, or array
}
  
  
  
